import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import xss from 'xss';
import { Typo } from 'tmt-ui-kit';

const Header = styled(Typo.HeaderTwo)`
  margin: 0 0 8px !important;
`;

const DetailText = styled(Typo.Paragraph)`
  white-space: pre-line;
`;

const CustomDetail = props => {
  const { trip } = props;
  return (
    <Fragment>
      <Header>Detail</Header>
      <DetailText
        dangerouslySetInnerHTML={{ __html: xss(trip.custom_detail) }}
      />
    </Fragment>
  );
};

CustomDetail.propTypes = {
  trip: PropTypes.object
};

export default CustomDetail;
